import type React from "react";

import { Stack, Text } from "@similarweb/ui-components/foundations";

import {
    StyledSuccessContainer,
    StyledSuccessIconWrapper,
} from "app/pages/sales-intelligence/common-components/GrandAccessBanner/styles";
import SuccessImage from "app/pages/sales-intelligence/common-components/GrandAccessBanner/SuccessImage";

type Props = {
    title: string;
    subTitle: string;
};

export const InlineSuccessBanner: React.FC<Props> = ({ title, subTitle }) => {
    return (
        <StyledSuccessContainer>
            <StyledSuccessIconWrapper>
                <SuccessImage />
            </StyledSuccessIconWrapper>
            <Stack gap="4px">
                <Text fontVariant="subtitle1">{title}</Text>
                <Text fontVariant="body2">{subTitle}</Text>
            </Stack>
        </StyledSuccessContainer>
    );
};
